import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {getAggregateErrorHandler} from './errorHandlers';
import {ErrorHandler} from '@di-nxt/resource-container';

type ErrorHandlerProp = {onError?: ErrorHandler};

export const withErrorHandler = <PropType extends ErrorHandlerProp>(
  Component: React.ComponentType<PropType>,
) => {
  return (props: PropType) => {
    const {onError} = props;
    const dispatch = useDispatch();
    const generalErrorHandler = useCallback(
      (error: Error) => {
        const handler = getAggregateErrorHandler(onError, dispatch);
        handler(error);
      },
      [dispatch, onError],
    );

    return <Component {...(props as PropType)} onError={generalErrorHandler} />;
  };
};
